export const ButtonStyles = {
  baseStyle: {
    borderRadius: "base",
    fontWeight: "normal",
  },
  variants: {
    solid: {
      backgroundColor: "primary",
      color: "secondary_text_color",
      border: "1px solid",
      borderColor: "teansparent",
      _hover: {
        backgroundColor: "primary",
        _disabled: {
          backgroundColor: "primary",
        },
      },
      _loading: {
        opacity: 0.7,
        pointerEvents: "none",
      },
    },

    solid_white: {
      backgroundColor: "white",
      color: "main_text_color",
      boxShadow: "primary",
      _hover: {
        backgroundColor: "white",
      },
    },

    solid_gray: {
      backgroundColor: "input_border_color_primary",
      color: "main_text_color",
      _hover: {
        backgroundColor: "input_border_color_primary",
      },
    },

    solid_dark_gray: {
      backgroundColor: "button_grey_bg",
      color: "white",
      _hover: {
        backgroundColor: "button_grey_bg",
      },
    },
    outlined_dark_gray: {
      backgroundColor: "white",
      color: "button_grey_bg",
      border: "1px solid",
      borderColor: "button_grey_bg",
      _hover: {
        backgroundColor: "primary",
        color: "white",
        borderColor: "primary",
      },
    },

    success: {
      backgroundColor: "success",
      color: "white",
      _hover: {
        backgroundColor: "success",
      },
    },

    error: {
      backgroundColor: "error",
      color: "white",
      _hover: {
        backgroundColor: "error",
      },
    },
  },
  sizes: {
    sm: {
      fontSize: "12px",
    },
    md: {
      fontSize: "16px",
    },
    l: {
      fontSize: "20px",
    },
  },
  defaultProps: {
    variant: "solid",
  },
}
